module.exports = __webpack_public_path__ + "img/openParty.1f025fde.png";